import * as React from "react";
const SvgCloud3 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 511.31", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 512, height: 511.31, style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("g", { id: "dark" }, /* @__PURE__ */ React.createElement("circle", { cx: 170.33, cy: 245.85, r: 67.89, style: {
  fill: "#2680c0",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 310.64, cy: 215.83, r: 110.98, style: {
  fill: "#1870af",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 96.55, cy: 316.11, r: 60.72, style: {
  fill: "#1870af",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 403.82, cy: 300.47, r: 76.18, style: {
  fill: "#2680c0",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 6
} }), /* @__PURE__ */ React.createElement("path", { d: "M400,308.63A83.28,83.28,0,0,1,316.63,392H149.89a37.9,37.9,0,1,1,8.27-74.88,51.56,51.56,0,0,1-.68-8.49,53,53,0,0,1,86.59-41.08A83.38,83.38,0,0,1,400,308.63Z", style: {
  fill: "#64b1e8",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("path", { d: "M316.63,392a83.31,83.31,0,0,0,22.74-3.14", style: {
  fill: "#64b1e8",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }))));
export default SvgCloud3;
